import { PRODUCT_CODE_VE } from "./awsConfig";

export const rootPath = "";

export const API_CANAL = "API-CANAL";
export const API_SEGURIDAD = "API-SEG";
export const ERROR_CODE_NOT_FOUND = "000013";
export const ERROR_CODE_NETWORK_ERROR = "000000";
export const ERROR_CODE_LEAD = "";
export const ERROR_CODE_AUDITORIA = "";

const getCodigoSubProducto = () => {
  let codigoSubProducto = 'comprar-seguro-';

  if (window.location.pathname.includes("vida-endoso-con-devolucion")) {
    return `${codigoSubProducto}vida-endoso-con-devolucion`;
  }

  if (window.location.pathname.includes("vida-plus")) {
    return `${codigoSubProducto}vida-plus`;
  }

  if (window.location.pathname.includes("seguro-viajes")) {
    return `${codigoSubProducto}viajes`;
  }

  return `${codigoSubProducto}vida-contigo`;
}

export const dataLead = {
  codigoSubProducto: getCodigoSubProducto(),
  tipoLead: 'comprar',
  usuarioCreacion: "VWEBPC",
  estado: "ACT",
};

export const dataAuditoria = {
  codigo: 'FLU-001',
  usuarioCreacion: 'USER_VCD',
};

export const StateMachine = {
  0: "Start",
  1: "Continue",
  4: "Error Api",
  5: "Error Dps Si",
  6: "Error Edad",
  7: "Error Biometrico",
  8: "End Flow",
  9: "Not Register",
  10: "Error Poliza Activa",
  11: "Error YellowList",
  12: "Error Cumulo",
  13: "Error BlackList",
  14: "Error Validar Tercero",
  15: "Cliente con CE"
};

export const UIStateMachine = {
  0: "Start",
  1: "Show Loading",
  2: "Hide Loading",
};

export const ROUTES = [
  '/comprar/seguro-vida-devolucion-garantizada',
  '/comprar/seguro-vida-devolucion-garantizada/cotizacion',
  '/comprar/seguro-vida-devolucion-garantizada/direccion',
  '/comprar/seguro-vida-devolucion-garantizada/pago',
  '/comprar/seguro-vida-devolucion-garantizada/gracias',
  '/comprar/seguro-vida-devolucion-garantizada/gracias-edad',
  '/comprar/seguro-vida-devolucion-garantizada/gracias-extranjeria',
  '/comprar/seguro-vida-devolucion-garantizada/cotizacion/gracias-prima',
  '/comprar/seguro-vida-devolucion-garantizada/gracias-ncliente',
  '/comprar/seguro-vida-devolucion-garantizada/datos-personales',
  '/comprar/seguro-vida-devolucion-garantizada/gracias-validacion',
  '/comprar/seguro-vida-devolucion-garantizada/error',
  '/comprar/seguro-vida-devolucion-garantizada/error-pago',
  '/comprar/seguro-vida-devolucion-garantizada/error-validacion',
  '/comprar/seguro-vida-plus',
  '/comprar/seguro-vida-plus/datos-personales',
  '/comprar/seguro-vida-plus/cotizacion',
  '/comprar/seguro-vida-plus/pago',
  '/comprar/seguro-vida-plus/gracias',
  '/comprar/seguro-vida-plus/error-pago',
  '/comprar/seguro-vida-plus/error',
  '/comprar/seguro-vida-plus/gracias-edad',
  '/comprar/seguro-vida-plus/gracias-extranjeria',
  '/comprar/seguro-vida-plus/gracias-ncliente',
  '/comprar/seguro-vida-plus/gracias-validacion',
  '/comprar/seguro-viajes',
  '/comprar/seguro-viajes/planes',
  '/comprar/seguro-viajes/datos',
  '/comprar/seguro-viajes/pago',
  '/comprar/seguro-viajes/gracias',
  '/comprar/seguro-viajes/gracias-ncliente',
  '/comprar/seguro-viajes/error',
  '/comprar/seguro-viajes/error-pago',
  '/comprar/seguro-vida-endoso-con-devolucion',
  '/comprar/seguro-vida-endoso-con-devolucion/datos-personales',
  '/comprar/seguro-vida-endoso-con-devolucion/gracias-validacion',
  '/comprar/seguro-vida-endoso-con-devolucion/cotizacion',
  '/comprar/seguro-vida-endoso-con-devolucion/declaracion-jurada',
  '/comprar/seguro-vida-endoso-con-devolucion/direccion',
  '/comprar/seguro-vida-endoso-con-devolucion/pago',
  '/comprar/seguro-vida-endoso-con-devolucion/gracias',
  '/comprar/seguro-vida-endoso-con-devolucion/error',
  '/comprar/seguro-vida-endoso-con-devolucion/error-pago',
  '/comprar/seguro-vida-endoso-con-devolucion/error-validacion',
];

export const VE_ROUTES_ENDORSEMENT = [
  {
    name: 'Personaliza tu plan',
    path: '/comprar/seguro-vida-endoso-con-devolucion/cotizacion',
  },
  {
    name: 'Datos sobre tu salud',
    path: '/comprar/seguro-vida-endoso-con-devolucion/declaracion-jurada',
    validation: 'checkShouldShowSuscription',
  },
  {
    name: 'Completa tus datos',
    path: '/comprar/seguro-vida-endoso-con-devolucion/direccion',
  },
  {
    name: 'Finaliza tu compra',
    path: '/comprar/seguro-vida-endoso-con-devolucion/pago',
  }
]

export const ROUTES_ENDORSEMENT = [
  '/comprar/seguro-vida-endoso-con-devolucion/cotizacion',
  '/comprar/seguro-vida-endoso-con-devolucion/direccion',
  '/comprar/seguro-vida-endoso-con-devolucion/pago',
]

export const SCREEN_NAMES_FOR_DIGITAL_DATA = {
  "/cotizacion": "Cotización",
  "/declaracion-jurada": "Declaración jurada",
  "/direccion": "Dirección",
  "/pago": "Resumen y pago",
};

export const inactiveErrorCodes = [
  1003,
  1005,
  1006,
  1007,
  1012,
  1016,
  1017,
  1018,
  1019
];

export const dataCoveragesIncluded = [
  {
      "coverageDescription": "Recibirás el monto de tu meta cuando culmine el tiempo elegido o en caso fallezcas.",
      "coverageTitle": "Vida ahorro",
      "coveragePlanIde": "PLAN_AHORRO",
      "coverageIde": "COBERTURA_FALLECIMIENTO_AHORRO_ADDONS",
      "coverageIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_savings.png"
    },
    {
      "coverageDescription": "Si falleces después del plazo de ahorro elegido, tus beneficiarios recibirán [currency][mount].",
      "coverageTitle": "Fallecimiento principal",
      "coveragePlanIde": "PLAN_AHORRO",
      "coverageIde": "COBERTURA_FALLECIMIENTO",
      "coverageIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_sepelio.png",
    },
    {
      "coverageDescription": "Si falleces dentro del plazo elegido, tus beneficiarios recibirán el monto de la meta de protección más el fallecimiento principal.",
      "coverageTitle": "Vida Protección",
      "coveragePlanIde": "PLAN_PROTECCION",
      "coverageIde": "COBERTURA_VIDA_ADICIONAL",
      "coverageIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_fallecimiento_adicional.png",
    },
    {
      "coverageDescription": "Si falleces después del plazo de ahorro elegido, tus beneficiarios recibirán [currency][mount].",
      "coverageTitle": "Fallecimiento principal",
      "coveragePlanIde": "PLAN_PROTECCION",
      "coverageIde": "COBERTURA_FALLECIMIENTO",
      "coverageIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_sepelio.png",
    },
    {
      "coverageDescription": "Al final del periodo de ahorro  recibirás [currency][mount].",
      "coverageTitle": "Devolución",
      "coveragePlanIde": "PLAN_LITE",
      "coverageIde": "COBERTURA_DEFAULT",
      "coverageLiteIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_savings.png"
    },
    {
      "coverageDescription": "Cobertura que dura toda la vida. Si falleces luego de finalizar el periodo de ahorro, tus beneficiarios recibirán [currency][mount].",
      "coverageTitle": "Fallecimiento principal",
      "coveragePlanIde": "PLAN_LITE",
      "coverageIde": "COBERTURA_FALLECIMIENTO",
      "coverageIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_sepelio.png"
    },
    {
      "coverageDescription": "Si falleces dentro del plazo de ahorro, tus beneficiarios recibirán [currency][mount] más el monto del fallecimiento principal.",
      "coverageTitle": "Fallecimiento adicional",
      "coveragePlanIde": "PLAN_LITE",
      "coverageIde": "COBERTURA_FALLECIMIENTO_AHORRO_ADDONS",
      "coverageIconPng": "/ventadigital/devolucion/assets/vc-coverage/icon_savings.png"
    }
];

export const LIMIT_OLDER_AGE = 64; // Valor máximo de edad por defecto permitida para el producto vida con devolución 200%
export const LIMIT_OLDER_AGE_PLUS = 60; // Valor máximo de edad por defecto permitida para el producto vida plus
export const LIMIT_OLDER_AGE_VIAJES = 80; // Valor máximo de edad por defecto permitida para el producto viajes
export const LIMIT_YOUNGER_AGE = 18; // Valor mínimo de edad por defecto requerida
export const IDE_TERCERO = 27122284;

export const TITLE_VCD = "Seguro de vida con devolución garantizada desde S/18.50 al mes | RIMAC";
export const DESCRIPTION_VCD = "Ahorra desde S/18.50 al mes con el seguro de vida con devolución garantizada de Rimac. Protege a tu familia y recibe hasta el 200% de tus aportes.";
export const TITLE_VCD_UNIVERSITARIO = "Cotizar Seguro Universitario | Te devolvemos hasta el 200% | RIMAC Seguros";
export const DESCRIPTION_VCD_UNIVERSITARIO = "Asegura el futuro de tus hijos con tu seguro de vida universitario. Recibe hasta el 200% de tus aportes. Cotiza online.";
export const TITLE_VD_PLUS = "Comprar Seguro Vida Plus | RIMAC Seguros";
export const TITLE_VIAJES = "Comprar Seguro de Viajes | RIMAC Seguros";
export const TITLE_VE = "Comprar Seguro Vida Endosable con devolución | RIMAC Seguros";
export const DESCRIPTION_VE = "Compra tu seguro de vida endosable con devolución. Rentabiliza tu dinero y recibe hasta el 150% de lo aportado.";

export const URL_VCD = "seguro-vida-devolucion-garantizada";
export const URL_VD_PLUS = "seguro-vida-plus";
export const URL_VIAJES = "seguro-viajes";
export const URL_VE = "seguro-vida-endoso-con-devolucion";

export const BDU_ORIGIN = "BDU";
export const AX_ORIGIN = "AX";
export const EQUIFAX_ORIGIN = "EQU";

export const TERCERO_ERROR = {
  INVALID_ERROR: "GCPRF004",
  RENIEC_ERROR: "GCGNR002"
};

export const CODE_VIDA_CT = {
  PRODUCT: PRODUCT_CODE_VE,
  APPLICATION: "WEBAPP001"
}

export const DEFAULT_COUNTRY = {
  id: 428,
  name: "PERU"
};

export const YES_NO_QUESTION_TYPE = 'YES_NO';
export const HEIGHT_WEIGHT_QUESTION = {
	code: 'HEIGHT_WEIGHT',
	type: 'NUMERIC_GROUP',
	label: '¿Cuánto mides y pesas?',
}

export const INTEGER_TYPE = 'integer'
export const FLOAT_TYPE = 'float'

export const SUSCRIPTION_FIELD_CONFIG_BY_CODE = {
  CD_001: {
    limits: {
      min: 10,
      max: 250,
    },
    format: {
      type: INTEGER_TYPE,
      integers: 3,
      step: 1
    },
  },
  CD_002: {
    limits: {
      min: 1,
      max: 999.9,
    },
    format: {
      type: FLOAT_TYPE,
      integers: 4,
      decimals: 1,
      step: 0.1
    },
  },
};

export const SUSCRIPTION_QUESTIONS_DIGITAL_DATA_NAMES = {
  SMART_Med_1: "Ingreso a hospital",
  SMART_Med_2: "Estudio médico",
  SMART_Med_3: "Control médico",
  SMART_Med_4: "Medicación regular",
  SMART_Med_5: "Enfermedad o invalidez",
  SMART_Med_6: "Licencia por salud",
  Extended_Occ: "Circunstancias laborales"
}
